import { createGlobalStyle } from "styled-components";

export enum ColorTokens {
  Primary = "--color-primary",
  PrimaryChill = "--color-primary-chill",
  PrimaryDark = "--color-primary-dark",
  PrimaryLight = "--color-primary-light",
  PrimaryExtraLight = "--color-primary-extra-light",

  Secondary = "--color-secondary",

  Tertiary = "--color-tertiary",
  TertiaryLight = "--color-tertiary-light",

  GreyMedium = "--color-grey-medium",
  Success = "--color-success",
}

export const GlobalStyle = createGlobalStyle`

:root {
    ${ColorTokens.Primary}: #6562df;
    ${ColorTokens.PrimaryChill}: #bdbcfd; 
    ${ColorTokens.PrimaryDark}: #1e1d6d;
    ${ColorTokens.PrimaryLight}: #cccbff;
    ${ColorTokens.PrimaryExtraLight}: #dbdaf4;

    ${ColorTokens.Secondary}: #fff6f5;

    ${ColorTokens.Tertiary}: #f45c65;
    ${ColorTokens.TertiaryLight}: #fff3f3;

    ${ColorTokens.GreyMedium}: #8f8e8e;
    ${ColorTokens.Success}: #91eb89;
  }
  select, input { 
    font-family: ${(props) => props.theme.font.family.title};
    margin: unset;
    font-size: 19px; // Minimum 19px for inputs to prevent Safari to zoom in on input focus..
  }

  * {
    font-weight: bold;
  }

  
`;
